export default __webpack_public_path__ + "static/media/ModelReleased.bc1ab617.png";